import { render, staticRenderFns } from "./ShippoLiveRate.vue?vue&type=template&id=b3bd191a&"
import script from "./ShippoLiveRate.vue?vue&type=script&lang=ts&"
export * from "./ShippoLiveRate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports